import { clearCustomAuthTokens, getCustomAuthTokens } from "../features/auth/LoginBox";
import { broadcastLogout } from "../utils/authBroadcast";

export const signOutRedirect = async () => {
  const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
  const logoutUri = import.meta.env.VITE_COGNITO_LOGOUT_URL;
  const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN;

  console.log("[AUTH][datasurfr][signOutRedirect.ts] signOutRedirect called");

  // [AUTH] broadcast logout to gosafe-frontend before clearing local state
  broadcastLogout("datasurfr");

  // [AUTH] 1. Clear local state
  console.warn("[AUTH][datasurfr][signOutRedirect.ts] Clearing localStorage");
  localStorage.clear();

  console.warn("[AUTH][datasurfr][signOutRedirect.ts] Clearing sessionStorage");
  sessionStorage.clear();

  // 2. Revoke refresh token on backend (also clears shared HttpOnly cookies)
  try {
    const authTokens = getCustomAuthTokens();
    const accessToken = authTokens?.access_token;

    if (accessToken) {
      const revokeResponse = await fetch(
        `${import.meta.env.VITE_API_INTERNAL_URL}/api/apps/auth/revoke-token`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          
          credentials: "include",
        }
      );

      if (revokeResponse.ok) {
        console.log("✅ Refresh token revoked successfully");
      } else {
        console.warn("⚠️ Token revocation failed, continuing with logout");
      }
    }
  } catch (err) {
    console.warn("Failed to revoke token, continuing with logout:", err);
  }

  // [AUTH] 3. Clear custom auth tokens from sessionStorage
  console.warn("[AUTH][datasurfr][signOutRedirect.ts] Clearing custom auth tokens");
  clearCustomAuthTokens();

  // [AUTH] 4. Redirect to Cognito /logout to kill the Cognito session
  const cognitoLogoutUrl = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  console.warn("[AUTH][datasurfr][signOutRedirect.ts] Redirecting to Cognito logout:", cognitoLogoutUrl);
  window.location.href = cognitoLogoutUrl;
};
